module.exports = __webpack_public_path__ + "static/remote-daca7ae84b0384a8811a231677ca2722.svg";